import { createAuthLoader } from "@shared-ui/loaders/auth-loader";
import { ENV } from "@/config/env";
import { setActiveTenantId } from "@/lib/apiClient";
import type { WhoamiMe } from "@shared-domain/auth-service/contract";

const AUTH_REFRESH = `${ENV.PRODUCT_API_ENDPOINT}/auth/refresh`;

export interface RootLoaderData {
  auth: WhoamiMe;
}

/**
 * Portal SSO 前提の認証 loader (unizo / dev-lab と同方式)。token が無ければ Portal に
 * リダイレクトし、戻ってきた one-time code をトークン交換 → whoami で現在ユーザ取得。
 */
export async function rootLoader({
  request,
}: {
  request: Request;
}): Promise<RootLoaderData> {
  const authLoader = createAuthLoader({
    apiEndpoint: ENV.PRODUCT_API_ENDPOINT,
    authPortalUrl: ENV.AUTH_PORTAL_URL,
    productId: ENV.PRODUCT_ID,
    tokenStoreName: "survey",
    userPoolId: ENV.COGNITO_USERPOOL_ID,
    clientId: ENV.CLIENT_ID,
    authRefreshUrl: AUTH_REFRESH,
    // PRODUCT_DEV-838: 専用テナントの環境では配信ホストがテナントを決める（unizo と同じ）。
    fixedTenantId: ENV.FIXED_TENANT_ID || undefined,
  });
  const auth = await authLoader({ request });
  // ログインユーザの現在テナントを API クライアントへ伝搬し全リクエストに自動付与。
  setActiveTenantId(auth.currentTenantId);
  return { auth };
}
